import { SubscriptionDTO } from "@campgladiator/cg-common.types.types";

export const getProgramProductTypeAndSubType: {
  [key: string]: {
    productType: SubscriptionDTO["productType"];
    productSubType: SubscriptionDTO["productSubType"];
  };
} = {
  onlineApproved: {
    productType: "BOOTCAMP",
    productSubType: "ONLINE",
  },
  outdoorApproved: {
    productType: "BOOTCAMP",
    productSubType: "IN_PERSON",
  },
  strengthApproved: {
    productType: "STRENGTH",
    productSubType: "IN_PERSON",
  },
  nutritionApproved: {
    productType: "NUTRITION",
    productSubType: "ONLINE",
  },
};
